import { logg } from '@/util/logg';

let API_URL_TEMP = import.meta.env?.VITE_API_URL;
export const CLIENT_ENV = import.meta.env?.VITE_ENV || 'DEV';

if (CLIENT_ENV === 'DEV') {
	logg('DEV MODE ENGAGED');
	API_URL_TEMP = import.meta.env?.VITE_API_URL_DEV;
}

logg('ENV VAR');
logg(API_URL_TEMP);

export const API_URL = API_URL_TEMP;
